var _rect, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailyForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 22,
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 43.75,
    height: 22,
    rx: 3,
    fill: "#20A486"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51652 15V7.245H12.2005C13.0732 7.245 13.8102 7.39533 14.4115 7.696C15.0202 7.99667 15.4785 8.43667 15.7865 9.016C16.1018 9.588 16.2595 10.2883 16.2595 11.117C16.2595 11.9383 16.1018 12.6387 15.7865 13.218C15.4785 13.7973 15.0202 14.241 14.4115 14.549C13.8102 14.8497 13.0732 15 12.2005 15H9.51652ZM10.6605 14.043H12.1345C13.1318 14.043 13.8725 13.801 14.3565 13.317C14.8478 12.833 15.0935 12.0997 15.0935 11.117C15.0935 10.1343 14.8478 9.40467 14.3565 8.928C13.8725 8.444 13.1318 8.202 12.1345 8.202H10.6605V14.043Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 9.66819H31.1972L33.1381 7.67055C31.2043 5.75792 28.0732 5.68708 26.1393 7.59971C24.2055 9.51943 24.2055 12.6151 26.1393 14.5348C28.0732 16.4545 31.2043 16.4545 33.1381 14.5348C34.1015 13.5855 34.5832 12.4734 34.5832 11.0708H36C36 12.4734 35.3766 14.2939 34.1299 15.5265C31.6435 17.9917 27.6057 17.9917 25.1193 15.5265C22.6399 13.0684 22.6187 9.07315 25.1051 6.61506C27.5915 4.15698 31.5797 4.15698 34.0661 6.61506L36 4.62451V9.66819ZM29.9788 8.16642V11.177L32.4581 12.6505L31.9481 13.5076L28.9162 11.7083V8.16642H29.9788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyForecast);
export default __webpack_public_path__ + "static/media/dailyForecast.7cbe85b6a77c59bbf54e633bd7aded6b.svg";
export { ForwardRef as ReactComponent };